import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonLibModule, ApiServiceConfig, ServerEventServiceConfig } from '@radsource/ng-common-lib';

import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Angular Material
import {
  MatProgressBarModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatGridListModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatInputModule,
  MatRadioModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSelectModule,
  MatSnackBarModule,
  MatMenuModule,
  MatCheckboxModule,
  MatTabsModule,
  MatIconModule,
  MatIconRegistry
} from '@angular/material';

//NG Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Component Imports
import { EditPatientComponent } from './components/edit-patient/edit-patient.component';
import { EditStudyComponent } from './components/edit-study/edit-study.component';
import { EditSeriesComponent } from './components/edit-series/edit-series.component';
import { PatientComponent } from './components/patient/patient.component';
import { StudyComponent } from './components/study/study.component';
import { SeriesComponent } from './components/series/series.component';
import { SOPComponent } from './components/sop/sop.component';
import { PacsLibComponent } from './ng-pacs-lib.component'

//Pipe Imports
import { ToDicomNamePipe } from './pipes/to-dicom-name.pipe';
import { FromDicomNamePipe } from './pipes/from-dicom-name.pipe';

//Service Imports
import { DicomService } from './services/dicom.service';
import { InstanceService } from './services/instance.service';

let apiConfig: ApiServiceConfig = {
  url: "stub",
  scheme: "stub"
}

let serviceConfig: ServerEventServiceConfig = {
  url: "stub",
  scheme: "stub"
}

@NgModule({
  declarations: [
    //Components
    EditPatientComponent,
    EditStudyComponent,
    EditSeriesComponent,
    PatientComponent,
    StudyComponent,
    SeriesComponent,
    SOPComponent,
    PacsLibComponent,

    //Pipes
    ToDicomNamePipe,
    FromDicomNamePipe,
  ],
  providers: [
    DicomService,
    InstanceService,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    MatMenuModule,
    MatCheckboxModule,
    MatTabsModule,
    MatIconModule,
    //RdsCommon
    CommonLibModule.forRoot(apiConfig, serviceConfig),
    //NG-Bootstrap Module
    NgbModule
  ],
  exports: [
    //Components
    EditPatientComponent,
    EditStudyComponent,
    EditSeriesComponent,
    PatientComponent,
    StudyComponent,
    SeriesComponent,
    SOPComponent,

    //Pipes
    ToDicomNamePipe,
    FromDicomNamePipe,
  ],
  bootstrap: [PacsLibComponent]
})
export class PacsLibModule {
  constructor(
    matIconRegistry: MatIconRegistry, 
    domSanitizer: DomSanitizer
  ) {
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
  }
}
